<script setup>
  import {MedButton, MedIcon} from "@pharma4u/medicheck-components";

  import DashboardWidget from "./Widget.vue";

  defineOptions({
    name: "DashboardPatientInputWidget",
  });
</script>

<template>
  <dashboard-widget :test-id="getTestId('patient-input')">
    <template #title>
      <MedButton
        as="inertia"
        flat
        class="text-2xl active:scale-97"
        align="left"
        :href="$route('patientinput-client.index')"
        :data-test="getTestId('patient-input-widget-route-to-patient-import-inertia-link-icon-button')"
      >
        <span class="flex rounded-full bg-mcgreen p-1.5 font-normal text-white">
          <MedIcon icon="note_alt" size="lg" />
        </span>

        Fragebögen
      </MedButton>
    </template>

    <template #default>
      <p class="text-lg">Arbeiten Sie Hand in Hand mit Patienten und Pflegefachkräften</p>
    </template>

    <template #actions>
      <MedButton
        as="inertia"
        variant="secondary"
        :href="$route('patientinput-client.index')"
        :data-test="getTestId('patient-input-widget-patient-input-list-button')"
      >
        Fragebögen verwalten
      </MedButton>
    </template>
  </dashboard-widget>
</template>
